import styled from 'styled-components'
import { Button } from 'react-angle-dashboard-components'
import { Link } from 'react-router-dom'

export const CongratulationsTopBar = styled.div`
  width: 100%;
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
`

export const CongratulationsHeader = styled.header`
  height: 131px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
`

export const CongratulationsTitle = styled.h1`
  font-size: 45px;
  color: #fff;
`

export const CongratulationsContent = styled.div`
  background: #dee2e6;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 59px 0;
`

export const CongratulationsP = styled.p`
  margin: 0;
  font-size: 20px;
  color: #343a40;
  max-width: 665px;
`

export const SectionTitle = styled.h2`
  font-size: 25px;
  color: #343a40;
  margin-top: 30px;
  margin-bottom: 22px;
`

export const ContributionLabel = styled.span`
  font-size: 20px;
  color: #343a40;
  margin-right: 15px;
`

export const ContributionData = styled.span`
  color: var(--primary);
  font-size: 20px;
`

export const BeginOnboardingButton = styled(Button)`
  padding: 0;
  font-size: 22px;
  color: #fff;
  height: 58px;
  width: 340px;
  margin-top: 47px;
  background-color: #e2ba40;
  margin-bottom: 18px;
  border: none;
  outline: none;
`

const linkStyles = `
font-size: 18px;
text-decoration: underline;
color: #343a40;
font-weight: 600;
margin-bottom: 65px;
`

export const LearnAboutLink = styled(Link)`
  ${linkStyles}
`

export const EditSelectionLink = styled(Link)`
  ${linkStyles}
`

export const ResourceWrapper = styled.div`
  margin-right: 20px;
  height: 79px;
  width: 285px;
`
